<template>
  <ValidationProvider :vid="vid" :name="$attrs.label" :rules="rules">
    <a-form-item
      slot-scope="{ errors, flags }"
      :label="showLabel ? $attrs.label : ''"
      :align="$attrs.align || 'left'"
      :validateStatus="resolveState({ errors, flags })"
      :help="errors[0]"
      :htmlFor="$attrs.htmlFor"
      :labelCol="$attrs.labelCol"
    >
      <a-textarea
        :autoSize="$attrs.autoSize || { minRows: 2, maxRows: 2 }"
        v-bind="$attrs"
        :style="{ width: '100% !important', ...($attrs.customStyle || {}) }"
        v-model="innerValue"
        @blur="$emit('blur', $event)"
        @change="$emit('change', $event)"
        @focus="$emit('focus', $event)"
      />
    </a-form-item>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationProvider,
  },
  emits: ["blur", "change", "focus", "input"],
  props: {
    showLabel: {
      type: Boolean,
      default: true,
    },
    vid: {
      type: String,
    },
    rules: {
      type: [Object, String, Array],
      default: "",
    },
    // must be included in props
    value: {
      type: null,
    },
  },
  data: () => ({
    innerValue: "",
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  methods: {
    resolveState({ errors, flags }) {
      if (errors[0]) {
        return "error";
      }

      if (flags.pending) {
        return "validating";
      }

      if (flags.valid) {
        return "success";
      }

      return "";
    },
  },
};
</script>
